<template>
  <span class="font-weight-bolder">
    <slot>
      {{ text }}
    </slot>
  </span>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>
